module.exports = __webpack_public_path__ + "img/tn.5cae0909.svg";